import Vue from 'vue'
import Router from 'vue-router'
// import { getUserInfo } from '@/utils/auth'

/* Layout */
import Layout from '@/layout'

Vue.use(Router)

/**
*注意:子菜单只在路由子菜单长度大于1时出现
*详情见:https://panjiachen.github.io/vue-element-admin-site/guide/essentials/route -and-nav.html
*
*hidden:true如果设置为true，项目将不会显示在侧栏中(默认为false)（隐藏）
*alwaysShow: true如果设置为true，将始终显示根菜单如果不设置alwaysShow，
*            当项目有多个子路由时，它将成为嵌套模式，否则不显示根菜单
*redirect:noRedirect 如果设置noRedirect，则在面包屑中不会重定向
* name:'router-name'这个名称由<keep-alive>(必须设置!!)
* meta: {
roles:['admin'，'editor']控制页面角色(可以设置多个角色)
title: 'title'  侧边栏和面包屑中显示的名称(推荐集)
icon:“svg-name”  图标显示在侧边栏中
breadcrumb: false  如果设置为false，则该项将隐藏在breadcrumb中(默认为true)
activeMenu: '/example/list'如果设置了路径，侧边栏将突出显示您设置的路径
}
*/

/**
 *constantRoutes
 *没有权限要求的基本页
 *所有角色都可以访问
 */
export const constantRoutes = [
  {
    path: '/admission/wx/login',
    component: () => import('@/views/admission/wx/Login.vue'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/register/register.vue'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/Home',
    children: [
      {
        path: 'Home',
        name: 'Home',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: '/kindergarten',
    component: Layout,
    alwaysShow: true,
    name: 'Kindergarten',
    meta: { title: '幼儿园管理', icon: 'KindergartenM', roles: [5, 6] },
    children: [
      {
        path: 'group',
        name: 'group',
        component: () => import('@/views/group/GroupList'),
        meta: { title: '集团管理', icon: 'groupN', roles: [6] }
      },
      {
        path: 'kindergarten',
        name: 'kindergarten',
        component: () => import('@/views/kindergarten/KindergartenList'),
        meta: { title: '幼儿园管理', icon: 'KindergartenN', roles: [6] }
      },
      {
        path: 'class',
        name: 'class',
        component: () => import('@/views/class/ClassList'),
        meta: { title: '班级管理', icon: 'ClassN', roles: [5, 6] }
      },
      {
        path: 'place',
        name: 'place',
        component: () => import('@/views/place/PlaceList'),
        meta: { title: '地点管理', icon: 'PlaceN', roles: [5, 6] }
      },
      {
        path: 'statistics',
        name: 'statistics',
        component: () => import('@/views/statistics/StatisticsDetail'),
        meta: { title: '统计管理', icon: 'StatisticsN', roles: [6] }
      },
      {
        path: 'optionalFunction',
        name: 'optionalFunction',
        component: () => import('@/views/optional-function/OptionalFunctionList'),
        meta: { title: '可选功能', icon: 'optionalFunction', roles: [6] }
      },
      {
        path: 'punch_setting',
        name: 'punch_setting',
        component: () => import('@/views/punch/PunchSetting'),
        meta: { title: '教师打卡设置', icon: 'punchSetting', roles: [5] }
      },
      {
        path: 'punch',
        name: 'punch',
        component: () => import('@/views/punch/PunchList'),
        meta: { title: '教师打卡记录', icon: 'punch', roles: [5] }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    alwaysShow: true,
    name: 'user',
    meta: { title: '用户管理', icon: 'User-managementN', roles: [5, 6, 15] },
    children: [
      {
        path: 'userAdministration',
        name: 'userAdministration',
        component: () => import('@/views/user/userList'),
        meta: { title: '用户管理', icon: 'User-managementW', roles: [5, 6, 15] }
      },
      {
        path: 'expert',
        name: 'expert',
        component: () => import('@/views/expert-teacher/ExpertTeacherList'),
        meta: { title: '专家与教师绑定', icon: 'expertN', roles: [5, 6, 15] }
      },
      {
        path: 'studentParent',
        name: 'studentParent',
        component: () => import('@/views/student-parent/StudentParentList'),
        meta: { title: '学生与家长绑定', icon: 'StudentN', roles: [5, 6, 15] }
      },
      {
        path: 'principal',
        name: 'principal',
        component: () => import('@/views/principal-kindergarten/PrincipalKindergartenList'),
        meta: { title: '园长与幼儿园绑定', icon: 'ceoN', roles: [6] }
      },
      {
        path: 'proTeacher',
        name: 'proTeacher',
        component: () => import('@/views/pro-teacher-kindergarten/ProTeacherKindergartenList'),
        meta: { title: '专业老师与幼儿园绑定', icon: 'ceoN', roles: [6] }
      },
      {
        path: 'doctor',
        name: 'doctor',
        component: () => import('@/views/doctor-student/DoctorStudentList'),
        meta: { title: '保健医与学生绑定', icon: 'DoctorN', roles: [5, 6] }
      },
      {
        path: 'busTeacher',
        name: 'busTeacher',
        component: () => import('@/views/bus-teacher-bus/BusTeacherBusList'),
        meta: { title: '校车老师与校车绑定', icon: 'DriverN', roles: [5, 6] }
      },
      {
        path: 'push',
        name: 'push',
        component: () => import('@/views/push/Push'),
        meta: { title: '推送通知', icon: 'DriverN', roles: [6] }
      }
    ]
  },
  {
    path: '/student',
    component: Layout,
    alwaysShow: true,
    name: 'student',
    meta: { title: '学生管理', icon: 'Student-management', roles: [1, 2, 3, 4, 5, 6, 7, 8, 11, 14, 15] },
    children: [
      {
        path: 'studentFile',
        name: 'studentFile',
        component: () => import('@/views/student/StudentList'),
        meta: { title: '学生档案', icon: 'archivesN', roles: [1, 3, 4, 5, 6, 7, 8, 11, 14, 15] }
      },
      {
        path: 'studentCheck',
        name: 'studentCheck',
        component: () => import('@/views/calendar/CalendarList'),
        meta: { title: '学生考勤', icon: 'CheckworkN', roles: [5] }
      },
      {
        path: 'studentSchoolBusCheck',
        name: 'studentSchoolBusCheck',
        component: () => import('@/views/calendar-school-bus/CalendarSchoolBusList'),
        meta: { title: '学生校车考勤', icon: 'CheckworkBus', roles: [5] }
      },
      {
        path: 'leaveNotes',
        name: 'leaveNotes',
        component: () => import('@/views/leave-notes/LeaveNotesList'),
        meta: { title: '假条补交', icon: 'leaveNotes', roles: [5] }
      },
      {
        path: 'studentAssessments',
        name: 'studentAssessments',
        component: () => import('@/views/student-assessments/StudentAssessmentsList'),
        meta: { title: '学生评量', icon: 'weighN', roles: [1, 3, 2] }
      },
      {
        path: 'studentAge06',
        name: 'studentAge06',
        component: () => import('@/views/age06/StudentAge06List'),
        meta: { title: '上海园园通学生关联', icon: 'archivesN', roles: [5] }
      }
    ]
  },
  {
    path: '/anecdotal',
    component: Layout,
    alwaysShow: true,
    name: 'anecdotal',
    meta: { title: '教学管理', icon: 'teachN', roles: [1, 2, 3, 4, 5, 6, 11] },
    children: [
      {
        path: 'anecdoteFile',
        name: 'anecdoteFile',
        component: () => import('@/views/anecdote/AnecdoteList'),
        meta: { title: '轶事记录', icon: 'RecordN', roles: [1, 2, 3, 4, 5, 11] }
      },
      {
        path: 'activity',
        name: 'activity',
        component: () => import('@/views/activity/ActivityList'),
        meta: { title: '课程记录', icon: 'curriculumN', roles: [1, 2, 3, 4, 5, 11] }
      },
      {
        path: 'teaching-plan',
        name: 'teaching-plan',
        component: () => import('@/views/teaching-plan/TeachingplanList'),
        meta: { title: '教案', icon: 'TeachingplanN', roles: [1, 2, 3, 4, 5, 11] }
      },
      {
        path: 'TeachingRecord',
        name: 'TeachingRecord',
        component: () => import('@/views/teaching-record/TeachingRecordList'),
        meta: { title: '教学记录', icon: 'teachingN', roles: [1, 3, 4, 5, 11] }
      },
      {
        path: 'StudentWorks',
        name: 'StudentWorks',
        component: () => import('@/views/student-works/StudentWorksList'),
        meta: { title: '学生作品', icon: 'worksN', roles: [1, 3, 4, 5, 11] }
      },
      {
        path: 'ExpertComment',
        name: 'ExpertComment',
        component: () => import('@/views/expert-work/ExpertWorkList'),
        meta: { title: '专家点评率', icon: 'CommentN', roles: [1] }
      },
      {
        path: 'predesign',
        name: 'predesign',
        component: () => import('@/views/predesign-teaching-plan/PredesignTeachingPlanList'),
        meta: { title: '预设教案', icon: 'healthyW', roles: [5, 6] }
      },
      {
        path: 'homeworks',
        name: 'homeworks',
        component: () => import('@/views/homework/HomeworkList'),
        meta: { title: '家庭作业', icon: 'homework', roles: [1, 3, 11] }
      }
      // {
      //   path: 'training',
      //   name: 'training',
      //   component: () => import('@/views/training/TrainingList'),
      //   meta: { title: '培训资料管理', icon: 'trainingW', roles: [5] }
      // }
    ]
  },
  {
    path: '/evaluate',
    component: Layout,
    hidden: true,
    name: 'evaluate',
    children: [
      {
        path: `evaluate1/:id`,
        name: 'evaluate1',
        component: () => import('@/views/evaluate/EvaluateAnecdote'),
        meta: { title: '轶事记录评价', icon: '', roles: [2] }
      },
      {
        path: `evaluate2/:id`,
        name: 'evaluate2',
        component: () => import('@/views/evaluate/EvaluateActivity'),
        meta: { title: '课程记录评价', icon: '', roles: [2] }
      },
      {
        path: `entrust`,
        name: 'entrust',
        component: () => import('@/views/evaluate/EvaluateEntrust'),
        meta: { title: '叮嘱反馈', icon: '', roles: [1, 3, 4, 7, 8] }
      },
      {
        path: `careGreetings`,
        name: 'careGreetings',
        component: () => import('@/views/evaluate/EvaluateCareGreetings'),
        meta: { title: '关怀问候反馈', icon: '', roles: [1, 3] }
      },
      {
        path: `LesunFaceDevicesStudentClass`,
        name: 'LesunFaceDevicesStudentClass',
        component: () => import('@/views/lesun-face-devices/DevicesStudentDetail'),
        meta: { title: '状态信息查询', icon: '', roles: [5, 6] }
      },
      {
        path: `CameraParkFaceDevicesStudentClass`,
        name: 'CameraParkFaceDevicesStudentClass',
        component: () => import('@/views/camera-park-face-devices/DevicesStudentDetail'),
        meta: { title: '状态信息查询', icon: '', roles: [5, 6] }
      }
    ]
  },
  {
    path: '/daily',
    component: Layout,
    alwaysShow: true,
    name: 'daily',
    meta: { title: '日常应用', icon: 'dailyW', roles: [1, 2, 3, 4, 5, 7, 8, 10, 11, 12, 14] },
    children: [
      {
        path: 'medication',
        name: 'medication',
        component: () => import('@/views/medication/MedicationList'),
        meta: { title: '服药单', icon: 'medicationW', roles: [7] }
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/notice/NoticeList'),
        meta: { title: '校园通知', icon: 'notice', roles: [1, 2, 3, 4, 7, 8, 10, 11, 12, 14] }
      },
      {
        path: 'leaveNotesTeacher',
        name: 'leaveNotesTeacher',
        component: () => import('@/views/leave-notes-teacher/LeaveNotesTeacherList'),
        meta: { title: '请销假', icon: 'leaveNotes', roles: [1, 3, 8] }
      },
      {
        path: 'entrust',
        name: 'entrustHome',
        component: () => import('@/views/entrust/EntrustList'),
        meta: { title: '叮嘱', icon: 'entrustHome', roles: [1, 3, 4, 7, 8], keepAlive: true }
      },
      {
        path: 'careGreetings',
        name: 'careGreetingsHome',
        component: () => import('@/views/care-greetings/CareGreetingsList'),
        meta: { title: '关怀问候', icon: 'careGreetings', roles: [1, 3] }
      },
      {
        path: 'epidemic',
        name: 'epidemic',
        component: () => import('@/views/epidemic/EpidemicList'),
        meta: { title: '健康日报', icon: 'healthyEpidemic', roles: [1, 5, 10] }
      },
      {
        path: 'formTemplate',
        name: 'formTemplate',
        component: () => import('@/views/form-templates/FormTemplatesList'),
        meta: { title: '表格模板', icon: 'forms', roles: [5] }
      },
      {
        path: 'form',
        name: 'form',
        component: () => import('@/views/form/FormList'),
        meta: { title: '表格管理', icon: 'forms', roles: [1, 2, 3, 7, 8, 11, 12, 14] }
      },
      {
        path: 'classCircle',
        name: 'classCircle',
        component: () => import('@/views/classCircle/ClassCircleList'),
        meta: { title: '班级圈', icon: 'classCircle', roles: [1, 3, 11] }
        // meta: { title: '班级圈', icon: 'classCircle', roles: [3], kindergartens: [1, 11] }
      }
    ]
  },
  // {
  //   path: '/babysitting',
  //   component: Layout,
  //   alwaysShow: true,
  //   name: 'babysitting',
  //   meta: { title: '托婴', icon: 'babysitting', roles: [3], babySit: getUserInfo() },
  //   children: [
  //     {
  //       path: 'mood',
  //       name: 'mood',
  //       component: () => import('@/views/mood/MoodList'),
  //       meta: { title: '宝贝情绪', icon: 'emotionW', roles: [3] }
  //     },
  //     {
  //       path: 'meal',
  //       name: 'meal',
  //       component: () => import('@/views/meal/MealList'),
  //       meta: { title: '三餐辅食', icon: 'complementaryW', roles: [3] }
  //     },
  //     {
  //       path: 'water',
  //       name: 'water',
  //       component: () => import('@/views/water/WaterList'),
  //       meta: { title: '日饮水量', icon: 'drinkingwaterW', roles: [3] }
  //     },
  //     {
  //       path: 'healthy',
  //       name: 'healthy',
  //       component: () => import('@/views/healthy/HealthyList'),
  //       meta: { title: '健康记录', icon: 'healthyW', roles: [3] }
  //     }
  //   ]
  // },
  {
    path: '/schoolBuses',
    component: Layout,
    alwaysShow: true,
    name: 'schoolBuses',
    meta: { title: '校车管理', icon: 'schoolBus', roles: [5, 6, 8] },
    children: [
      {
        path: 'schoolBus',
        name: 'schoolBus',
        component: () => import('@/views/school-bus/SchoolBusList'),
        meta: { title: '校车管理', icon: 'schoolBusW', roles: [5, 6] }
      },
      {
        path: 'schoolBusDownload',
        name: 'schoolBusDownload',
        component: () => import('@/views/school-bus-download/SchoolBusDownload'),
        meta: { title: '资料下载', icon: 'schoolBusW', roles: [8] }
      }
    ]
  },
  {
    path: '/devices',
    component: Layout,
    alwaysShow: true,
    name: 'devices',
    meta: { title: '外部设备管理', icon: 'devicesW', roles: [5, 6] },
    children: [
      {
        path: 'lesunFaceDevices',
        name: 'lesunFaceDevices',
        component: () => import('@/views/lesun-face-devices/LesunFaceDevicesList'),
        meta: { title: '磊盛人脸识别设备管理', icon: 'faceW', roles: [5, 6] }
      },
      {
        path: 'cameraParkFaceDevices',
        name: 'cameraParkFaceDevices',
        component: () => import('@/views/camera-park-face-devices/CameraParkFaceDevicesList'),
        meta: { title: '厂拍人脸识别设备管理', icon: 'faceW', roles: [5, 6] }
      },
      {
        path: 'ysCamera',
        name: 'ysCamera',
        component: () => import('@/views/ys-camera/YsCameraList'),
        meta: { title: '萤石监控设备管理', icon: 'ysCamera', roles: [5, 6] }
      },
      {
        path: 'studentIc',
        name: 'studentIc',
        component: () => import('@/views/student-ic/StudentIcList'),
        meta: { title: '学生IC卡管理', icon: 'studentIc', roles: [5] }
      }
    ]
  },
  {
    path: '/admission/wx',
    component: { render: (e) => e('router-view') },
    hidden: true,
    name: 'admission_wx',
    meta: { title: '招生小程序', roles: [13] },
    children: [
      {
        path: 'introduction',
        name: 'introduction',
        component: () => import('@/views/admission/wx/Introduction'),
        meta: { title: '', roles: [13] }
      }
    ]
  },
  {
    path: '/tuition',
    component: Layout,
    alwaysShow: true,
    name: 'tuition',
    meta: { title: '财务', icon: 'tuitionW', roles: [4, 14] },
    children: [
      {
        path: 'templates',
        name: 'templates',
        component: () => import('@/views/tuition-bills-templates/TuitionBillsTemplatesList'),
        meta: { title: '学费单模板', icon: 'templateW', roles: [14] }
      },
      {
        path: 'bills',
        name: 'bills',
        component: () => import('@/views/tuition-bills/TuitionBillsList'),
        meta: { title: '学费单', icon: 'tuitionbillsW', roles: [4, 14] }
      },
      {
        path: 'refundCaculations',
        name: 'refundCaculations',
        component: () => import('@/views/refund-caculations/RefundCaculationsList'),
        meta: { title: '退费计算方法', icon: 'refundCaculations', roles: [14] }
      },
      {
        path: 'fee',
        name: 'fee',
        component: () => import('@/views/tuition-fee/TuitionFeeList'),
        meta: { title: '学费档案', icon: 'tuitionFee', roles: [14] }
      },
      {
        path: 'payrolls',
        name: 'payrolls',
        component: () => import('@/views/payrolls/payrolls'),
        meta: { title: '工资单', icon: 'payrolls', roles: [14] }
      },
      {
        path: 'deposit',
        name: 'deposit',
        component: () => import('@/views/tuition-deposit/TuitionDepositList'),
        meta: { title: '预缴学费管理', icon: 'payrolls', roles: [14] }
      },
      {
        path: 'reconciliation',
        name: 'reconciliation',
        component: () => import('@/views/admission/reconciliation/ReconciliationList'),
        meta: { title: '业财对账', icon: 'weighN', roles: [14] }
      }
    ]
  },
  {
    path: '/assessment',
    component: Layout,
    alwaysShow: true,
    name: 'assessment',
    meta: { title: '评量管理', icon: 'assessment', roles: [6] },
    children: [
      {
        path: 'objectives',
        name: 'objectives',
        component: () => import('@/views/assessment-objectives/AssessmentObjectivesList'),
        meta: { title: '类别与指标', icon: 'objectives', roles: [6] }
      },
      {
        path: 'checklists',
        name: 'checklists',
        component: () => import('@/views/assessment-checklists/AssessmentChecklistsList'),
        meta: { title: '评量清单管理', icon: 'tuitionbillsW', roles: [6] }
      }
    ]
  },
  {
    path: '/personal-info-protection',
    component: Layout,
    alwaysShow: true,
    name: 'personalInfoProtection',
    meta: { title: '个人信息保护', icon: 'User-managementN', roles: [5] },
    children: [
      {
        path: 'dataProcessing',
        name: 'dataProcessing',
        component: () => import('@/views/personal-info-protection/DataProcessing'),
        meta: { title: '数据处理', icon: 'StudentN', roles: [5] }
      }
    ]
  },
  {
    path: '/admission',
    component: Layout,
    alwaysShow: true,
    name: 'admission',
    meta: { title: '招生', icon: 'Student-management', roles: [1, 9, 12, 16] },
    children: [
      {
        path: 'customerList',
        name: 'customerList',
        component: () => import('@/views/admission/customer/CustomerList'),
        meta: { title: '客户信息', icon: 'archivesN', roles: [1, 9, 12, 16] }
      },
      {
        path: `communicationRecordList`,
        name: 'communicationRecordList',
        hidden: true,
        component: () => import('@/views/admission/customer/CommunicationRecordList'),
        meta: { title: '沟通记录', icon: '', roles: [12, 16] }
      },
      {
        path: `appointmentList`,
        name: 'appointmentList',
        hidden: true,
        component: () => import('@/views/admission/customer/AppointmentList'),
        meta: { title: '预约记录', icon: '', roles: [12, 16] }
      },
      {
        path: 'reconciliation',
        name: 'reconciliation',
        component: () => import('@/views/admission/reconciliation/ReconciliationList'),
        meta: { title: '业财对账', icon: 'weighN', roles: [1, 12] }
      },
      {
        path: 'weeklyReport',
        name: 'weeklyReport',
        component: () => import('@/views/admission/weekly-report/WeeklyReportList'),
        meta: { title: '周报', icon: 'healthyEpidemic', roles: [1, 9, 12, 16] }
      },
      {
        path: 'chargingStandard',
        name: 'chargingStandard',
        component: () => import('@/views/admission/changing-standard/ChargingStandardList'),
        meta: { title: '收费标准', icon: 'tuitionbillsW', roles: [1, 9, 12, 16] }
      },
      {
        path: 'classSituation',
        name: 'classSituation',
        component: () => import('@/views/admission/class-situation/ClassSituationList'),
        meta: { title: '班级状况', icon: 'ClassN', roles: [1, 9, 12, 16] }
      },
      {
        path: 'yearPlan',
        name: 'yearPlan',
        component: () => import('@/views/admission/year-plan/YearPlanList'),
        meta: { title: '招生年度计划', icon: 'CheckworkBus', roles: [1, 9, 12, 16] }
      },
      {
        path: 'clueOpportunity',
        name: 'clueOpportunity',
        component: () => import('@/views/admission/clue-opportunity/ClueOpportunityList'),
        meta: { title: '客户线索与商机', icon: 'objectives', roles: [1, 9, 12, 16] }
      },
      {
        path: 'customerSource',
        name: 'customerSource',
        component: () => import('@/views/admission/customer-source/CustomerSourceList'),
        meta: { title: '客户来源分析', icon: 'StatisticsN', roles: [1, 9, 12, 16] }
      },
      {
        path: 'actualAnalysis',
        name: 'actualAnalysis',
        component: () => import('@/views/admission/actual-analysis/ActualAnalysisList'),
        meta: { title: '实际招生人数分析', icon: 'StatisticsN', roles: [1, 9, 12, 16] }
      },
      {
        path: 'dropOutAnalysis',
        name: 'dropOutAnalysis',
        component: () => import('@/views/admission/drop-out-analysis/DropOutAnalysisList'),
        meta: { title: '退园人数分析', icon: 'StatisticsN', roles: [1, 9, 12, 16] }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]
const createRouter = () =>

  new Router({
    // mode: 'history', // require service support
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0 }
      }
    },
    routes: constantRoutes
  })

// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = createRouter()

// store/modules/user
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js